var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 302.314,
    height: 248.368,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.531 83.207H10.279A10.218 10.218 0 0 0 0 93.424v118.317a10.52 10.52 0 0 0 10.279 10.589H59.5c5.683 0 10.031-4.876 10.031-10.589V93.424a9.965 9.965 0 0 0-10-10.217zm-29.408 7.142h9.316a1.242 1.242 0 0 1 0 2.484h-9.316a1.242 1.242 0 1 1 0-2.484zm4.813 127.322a5.4 5.4 0 1 1 5.4-5.4 5.407 5.407 0 0 1-5.4 5.401zm29.036-15.217H5.59a.623.623 0 0 1-.621-.621V99.666a.623.623 0 0 1 .621-.621h58.382a.623.623 0 0 1 .621.621v102.168a.623.623 0 0 1-.621.621zM298.488 3.88A13.26 13.26 0 0 0 289.121 0H138.247A13.247 13.247 0 0 0 125 13.247v221.766a13.247 13.247 0 0 0 13.247 13.247h150.819a13.247 13.247 0 0 0 13.247-13.247V13.247a12.978 12.978 0 0 0-3.825-9.367zm-85.026 5.376a3.88 3.88 0 1 1-3.88 3.88 3.928 3.928 0 0 1 3.88-3.88zm.222 233.516a7.788 7.788 0 1 1 7.815-7.815 7.952 7.952 0 0 1-7.815 7.816zM293.5 221.71H133.868V26.605H293.5z",
    fill: "#0b72b9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.652 109.245H55.609c-5.836 0-10.609 5.691-10.609 12.648v113.828c0 6.956 4.773 12.647 10.609 12.647h53.043c5.836 0 10.609-5.691 10.609-12.648V121.893c-.001-6.957-4.774-12.648-10.609-12.648zm1.326 122.013h-55.7V127.09h55.7z",
    fill: "#0b72b9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54 127h56v105H54z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobileIcon.17cd04f1804a1b2daeb5947742410ab1.svg";
export { ForwardRef as ReactComponent };